// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.help-icon {
    color: #838383;
    font-size: 16px;
}

.app-tooltip {
    display: inline-block !important;
}

.material-icons {
    transform: translateY(-5px);
}
`, "",{"version":3,"sources":["webpack://./src/app/shared/components/tooltip/tooltip.component.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,2BAA2B;AAC/B","sourcesContent":[".help-icon {\n    color: #838383;\n    font-size: 16px;\n}\n\n.app-tooltip {\n    display: inline-block !important;\n}\n\n.material-icons {\n    transform: translateY(-5px);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
